import { Component } from 'vue-property-decorator';
import { Page } from '../../helpers/components';
import { BasePage } from '../base-page';

@Page(null) @Component
export class EmptyPage extends BasePage {
}

export default EmptyPage;
